import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const DeleteSuccessAlert = ({
  message = "Record deleted successfully!",
  onClose,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
          padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 320,
          borderRadius: 4,
          textAlign: "center",
          p: 3,
        }}
      >
        <CardContent>
          <DeleteForeverIcon
            sx={{
              fontSize: 70,
              color: "error.main",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold">
            Deleted Successfully
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={onClose}
            sx={{ borderRadius: 3 }}
          >
            OK
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DeleteSuccessAlert;